<template lang="pug">
  .three-columns.container
    .row
      .column.small-12.medium-4(v-for="column in columns")
        single-column(
          :image="column.image"
          :title="column.title"
          :link="column.link"
        )
</template>

<script>
  import SingleColumn from 'scripts/components/basic/SingleColumn.vue'

  export default {
    name: 'ThreeColumns',
    components: {
      SingleColumn
    },
    props: {
      columns: Array
    }
  }
</script>

<style lang="scss" scoped>
  .three-columns {
    margin-top: 54px;
    margin-bottom: $grid-gutter / 2;

    @include tablet-up {
      margin-bottom: 54px;
    }

    .column {
      margin-bottom: $grid-gutter / 2;

      @include tablet-up {
        margin-bottom: 0;
      }
    }
  }
</style>